import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import { useCrmEnrichmentJobRenameMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobRenameMutation";

import { hubspotEnrichmentQueryKeys } from "../queries/queryKeyFactory";
import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

export default function useHsEnrichmentJobRenameMutation() {
    const dispatch = useDispatch();

    return useCrmEnrichmentJobRenameMutation({
        apiService: hubspotEnrichmentAPIService,
        queryKeys: hubspotEnrichmentQueryKeys,
        onSuccessCallback: () => {
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text: translate("si.crm-enrichment.hs.name-modal.success.rename"),
                    }),
                ),
            );
        },
    });
}
